module.exports = __webpack_public_path__ + "static/img/gift-box-open.06e08951.webp";